import React from 'react';

import styled, {css} from "styled-components";

const Input = styled.input`
  && {
    background: #FFFFFF;
    border: 1px solid rgba(46, 44, 71, 0.313377);
    border-radius: 3px;
    font-size: 17px;
    line-height: 23px;
    color: rgba(46, 44, 71, 0.765115);
    resize: none;
    
    ${props => !props.valid && css`
        border-color: red;
    `}
  }
`;

export {Input};
